// @ts-nocheck
import { supabase } from '@/integrations/supabase/client';
import { invokeEdgeFunction } from "@/lib/invokeEdgeFunction";

const DEMO_EVENT_ID = 'f83c2769-b4aa-4ba9-9e3e-5e205fd40047';

export interface SeedOptions {
  teamsPerDivision?: number;
  playersPerTeam?: number;
  divisions?: string[];
}

export interface SeedResults {
  coaches: number;
  teams: number;
  players: number;
  registrations: number;
  errors: string[];
}

const callSeedFunction = async (body: Record<string, any>) => {
  const { data, error } = await invokeEdgeFunction('seed-demo-data', {
    body,
  });
  if (error) throw error;
  return data;
};

export const seedDemoData = async (options: SeedOptions = {}): Promise<SeedResults> => {
  const result = await callSeedFunction({
    action: 'seed',
    eventId: DEMO_EVENT_ID,
    divisions: options.divisions || ['13U', '14U', '15U', '16U'],
    teamsPerDivision: options.teamsPerDivision || 4,
    playersPerTeam: options.playersPerTeam || 10,
  });

  if (result.error) throw new Error(result.error);

  return {
    coaches: result.coaches || 0,
    teams: result.teams || 0,
    players: result.players || 0,
    registrations: result.registrations || 0,
    errors: result.errors || [],
  };
};

export const clearDemoData = async (): Promise<void> => {
  const result = await callSeedFunction({
    action: 'clear',
    eventId: DEMO_EVENT_ID,
  });
  if (result.error) throw new Error(result.error);
};

export const getDemoStats = async () => {
  const result = await callSeedFunction({
    action: 'stats',
    eventId: DEMO_EVENT_ID,
  });
  if (result.error) throw new Error(result.error);
  return {
    teams: result.teams || 0,
    registrations: result.registrations || 0,
    players: result.players || 0,
  };
};